import React from 'react';
import { isEmpty } from 'lodash';

// copied from masala-console.
// @armando, better home for this?

const prevent =
  (action: () => {}) => (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    action();
  };

export const ActionLink = ({
  onPress = () => {},
  className = '',
  title = '',
  children,
}: {
  onPress: () => any;
  className?: string;
  title?: string;
  children?: React.ReactNode;
}) => {
  return (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <a href="#" className={className} onClick={prevent(onPress)}>
      {/* fontSize={1} mr={2}> */}
      {title}
      {children}
    </a>
  );
};

export const A = ({
  href,
  className = '',
  children = null,
}: {
  href: string;
  className?: string;
  children?: React.ReactNode;
}) => {
  if (isEmpty(href)) {
    return null; //children;
  }

  const body = isEmpty(children) ? href : children;
  return (
    <a href={href} className={className} target="_blank" rel="noreferrer">
      {body}
    </a>
  );
};
